import { useMediaQuery } from './useMediaQuery';

// Tailwind breakpoints
export const BREAKPOINTS = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1536,
} as const;

/**
 * Hook to detect mobile viewport (< 768px)
 */
export function useMobile(): boolean {
  return useMediaQuery(`(max-width: ${BREAKPOINTS.md - 1}px)`);
}

/**
 * Hook to detect tablet viewport (768px - 1023px)
 */
export function useTablet(): boolean {
  const isAboveMobile = useMediaQuery(`(min-width: ${BREAKPOINTS.md}px)`);
  const isBelowDesktop = useMediaQuery(`(max-width: ${BREAKPOINTS.lg - 1}px)`);
  return isAboveMobile && isBelowDesktop;
}

/**
 * Hook to detect touch device
 */
export function useTouchDevice(): boolean {
  return useMediaQuery('(hover: none) and (pointer: coarse)');
}

/**
 * Combined responsive hook for complex layouts
 */
export function useResponsive() {
  const isMobile = useMobile();
  const isTablet = useTablet();
  const isTouch = useTouchDevice();

  return {
    isMobile,
    isTablet,
    isDesktop: !isMobile && !isTablet,
    isTouch,
    breakpoint: isMobile ? 'mobile' : isTablet ? 'tablet' : 'desktop',
  } as const;
}
